import { unitsAction, getType } from '../../actions/index';
const shortid = require('shortid');

const initialState = {
    list: [],
}

const notificationReducer = (state = initialState, action) => {
    switch (action.type) {
        case getType(unitsAction.fetchNotification):
            return {
                ...state,
                list: action.payload || [],
            }
        case getType(unitsAction.resetNotification):
            return {
                ...state,
                list: [],
            }
        case getType(unitsAction.changeNotification): {
            const newNotification = {
                _id: action.payload._id || shortid.generate(),
                title: action.payload.title,
                note: action.payload.note || action.payload.message || "",
                message: action.payload.message || action.payload.note || "",
                booking_id: action.payload.booking_id || "",
                reservation_id: action.payload.reservation_id || "",
                membershipId: action.payload.membershipId || "",
                branchID: action.payload.branchID || null,
                roomSelect: action.payload.roomSelect || "",
                checkin: action.payload.checkin || "",
                type: action.payload.type || "info",
                priority: action.payload.priority || "medium",
                isRead: action.payload.isRead || false,
                createdAt: action.payload.createdAt || new Date().toISOString(),
                updatedAt: action.payload.updatedAt || new Date().toISOString(),
            };

            const filteredList = state.list.filter((item) => item._id !== newNotification._id);
            return {
                ...state,
                list: [newNotification, ...filteredList],
            }
        }
        case getType(unitsAction.markNotificationAsRead): {
            return {
                ...state,
                list: state.list.map((item) => item._id === action.payload
                    ? { ...item, isRead: true, updatedAt: new Date().toISOString() }
                    : item),
            };
        }
        case getType(unitsAction.markAllNotificationsAsRead): {
            return {
                ...state,
                list: state.list.map((item) => ({
                    ...item,
                    isRead: true,
                    updatedAt: new Date().toISOString(),
                })),
            };
        }
        default:
            return state
    }
}

export default notificationReducer;